export const GLOSSARY_SEARCH_TEXT_CHANGE = Symbol('GLOSSARY_SEARCH_TEXT_CHANGE')
export const COPY_GLOSSARY_TERM = Symbol('COPY_GLOSSARY_TERM')
/* API request for glossary search has started. */
export const GLOSSARY_TERMS_REQUEST = Symbol('GLOSSARY_TERMS_REQUEST')
/* API request for glossary search has completed successfully. */
export const GLOSSARY_TERMS_SUCCESS = Symbol('GLOSSARY_TERMS_SUCCESS')
/* API request for glossary search has failed. */
export const GLOSSARY_TERMS_FAILURE = Symbol('GLOSSARY_TERMS_FAILURE')
/* Indicates the index in glossary results that should have details displayed */
export const SET_GLOSSARY_DETAILS_INDEX = Symbol('SET_GLOSSARY_DETAILS_INDEX')
/* Set whether glossary details modal is showing */
export const SHOW_GLOSSARY_DETAILS = Symbol('SHOW_GLOSSARY_DETAILS')
/* API request for glossary details has started. */
export const GLOSSARY_DETAILS_REQUEST = Symbol('GLOSSARY_DETAILS_REQUEST')
/* API request for glossary details has completed successfully. */
export const GLOSSARY_DETAILS_SUCCESS = Symbol('GLOSSARY_DETAILS_SUCCESS')
/* API request for glossary details has failed. */
export const GLOSSARY_DETAILS_FAILURE = Symbol('GLOSSARY_DETAILS_FAILURE')



// WEBPACK FOOTER //
// ./app/editor/actions/glossary-action-types.js